/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Points awarded per match outcome. Field names match the LeaguePointsConfig model; the admin UI submits these exact keys. Prior naming (`win`/`draw`/`loss`) was a handler-side shorthand that the admin frontend never matched, so non-default operator entries were silently dropped — see R1 round-2 review.
 * @export
 * @interface CreateLeagueBodyPointsConfig
 */
export interface CreateLeagueBodyPointsConfig {
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBodyPointsConfig
     */
    pointsPerWin?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBodyPointsConfig
     */
    pointsPerDraw?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLeagueBodyPointsConfig
     */
    pointsPerLoss?: number;
}

/**
 * Check if a given object implements the CreateLeagueBodyPointsConfig interface.
 */
export function instanceOfCreateLeagueBodyPointsConfig(value: object): value is CreateLeagueBodyPointsConfig {
    return true;
}

export function CreateLeagueBodyPointsConfigFromJSON(json: any): CreateLeagueBodyPointsConfig {
    return CreateLeagueBodyPointsConfigFromJSONTyped(json, false);
}

export function CreateLeagueBodyPointsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeagueBodyPointsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsPerWin': json['pointsPerWin'] == null ? undefined : json['pointsPerWin'],
        'pointsPerDraw': json['pointsPerDraw'] == null ? undefined : json['pointsPerDraw'],
        'pointsPerLoss': json['pointsPerLoss'] == null ? undefined : json['pointsPerLoss'],
    };
}

export function CreateLeagueBodyPointsConfigToJSON(json: any): CreateLeagueBodyPointsConfig {
    return CreateLeagueBodyPointsConfigToJSONTyped(json, false);
}

export function CreateLeagueBodyPointsConfigToJSONTyped(value?: CreateLeagueBodyPointsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsPerWin': value['pointsPerWin'],
        'pointsPerDraw': value['pointsPerDraw'],
        'pointsPerLoss': value['pointsPerLoss'],
    };
}

